require('./angular-route');
module.exports = 'ngRoute';



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins-rpmbuild/BUILD/StarNetFastX2-2.4-16/fastx-client-js-stage/node_modules/angular-route/index.js
// module id = 1
// module chunks = 0